module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNi4zNyA5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzM4MzgzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmljX2NoZXZyb25fdXA8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjEuODggOSA4LjE4IDIuMDcgMTQuNDcgOSAxNi4zNyA5IDguMTggMCAwIDkgMS44OCA5Ii8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_chevron_up.svg
// module id = MUeO
// module chunks = 1